export const nationalCodeValidation = (code) => {
  let length = code.length;

  if (length !== 10 || parseInt(code, 10) == 0) return false;

  code = ("0000" + code).substr(length + 4 - 10);

  if (parseInt(code.substr(3, 6), 10) == 0) return false;

  let c = parseInt(code.substr(9, 1), 10);

  let s = 0;

  for (let i = 0; i < 9; i++) s += parseInt(code.substr(i, 1), 10) * (10 - i);

  s = s % 11;

  return (s < 2 && c == s) || (s >= 2 && c == 11 - s);
};

export const emailValidation = (email) => {
  let reg = /^([\w-\\.]+@([\w-]+\.)+[\w-]{2,6})?$/;

  return email ? reg.test(email) : undefined;
};

export const englishAlphabetValidation = (text) => {
  let reg = /^[a-zA-Z]{3,}$/;

  return reg.test(text);
};

export const englishAlphabetWithSpaceValidation = (text) => {
  let reg = /^[ a-zA-Z]*$/;

  return reg.test(text);
};

export const persianAlphabetValidation = (text) => {
  let reg = /^[\u0627-\u06CC\u0622\u0643\u0624\u064A\u0626\u0020\u200C]*$/;

  return reg.test(text);
};

export const persianAlphabetWithSpaceValidation = (text) => {
  let reg = /^[\u0627-\u06CC\u0622\u0643\u0624\u064A\u0626\u0020\u200C]*$/;

  return reg.test(text);
};

export const mobileValidation = (mobile) => {
  let reg = /^(\+98|0)9\d{9}$/;

  return reg.test(mobile);
};

export const telephoneValidation = (telephone) => {
  let reg = /0[0-9]{6,10}$/;

  return reg.test(telephone);
};
